import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS type
import { Area, TStep, IThsrTripInfo } from '@redux/common';
// Redux
import { RootState } from '@redux/store';

// import module
import NvbRslb from '@magaele/nvb_rslb';
import IcRcln from '@magaele/ic_rcln';

// component
import THSRPanel from './subComponent/THSRPanel';

// source config
import MobileHeader from '@Common/mobileHeader';

// styles
import '../CommonStyles/THSR.scss';

// common function
import { addSeparator } from 'libs/core';
import { handletBodyFixed, generateDates } from '@libs/core';
import { isMobile } from '@libs/globalVariables';

// plugin
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

// redux actions
import {
    setTHSROptsMOpen,
    setTHSRDetailData,
    setTCurrentStep,
    setTHSROpenedPanel,
    setTHSRDepartTrain,
    setTHSRReturnTrain,
    setTHSRHighestDiscounts,
} from '@redux/THSR/actions';
import { setTGRestore } from '@redux/GDST/actions';
import { setFocusArea, setDetailFetchFailMsg } from '@redux/Common/actions';
import { setTRestore } from '@redux/NormalT/actions';
import AddOnPriceTag from '@component/Common/AddOnPriceTag';

interface NormalRailPanelProps {
    THSRTripType: string;
    THSRTripInfo: IThsrTripInfo;
    isTHSRPanelOpen: boolean;
    listIndex: number;
    children?: any; // GDSTHSR or NormalTHSR
    isCrossell?: boolean;
}

const NormalRailPanel: React.FC<NormalRailPanelProps> = (props) => {
    const dispatch = useDispatch();
    const  THSRTripInfo =  props.THSRTripInfo; // 從THSRInitData分類好傳下來的單OR雙程資訊
    const { t } = useTranslation();
    const {isCrossell} = props

    const store_THSR = useSelector((state: RootState) => state.THSR);
    const { isDetailLoading } = useSelector((state: RootState) => state.Normal);
    const { MInfoShow } = useSelector((state: RootState) => state.NormalT);
    const { isGDSDetailLoading, isGDSSessionLoading } = useSelector((state: RootState) => state.GDS);
    const { TGMInfoShow, salePriceSpread, showCrossellTag } = useSelector((state: RootState) => state.GDST);
    const { isGDS, DetailFetchFailMsg } = useSelector((state: RootState) => state.Common);

    const [openTHSRNvbRslb, setOpenTHSRNvbRslb] = useState<boolean>(false); //是否開啟側開
    const listBlockRef = useRef(null);

    //計算出最高折扣的方案 TODO:與DiscountOff陣列有關
    // const calcHighestDiscount = () => {
    //     dayjs.extend(isSameOrAfter);
    //     dayjs.extend(isSameOrBefore);
    //     let highestDiscount = null;
    //     //根據折扣高到低排序
    //     let sortedDiscount =
    //         store_THSR.THSRInitData?.DiscountOff && store_THSR.THSRInitData?.DiscountOff.length > 0
    //             ? [...store_THSR.THSRInitData?.DiscountOff].sort((a, b) =>
    //                   a.percentOff > b.percentOff ? -1 : 1
    //               )
    //             : [];
    //     sortedDiscount.forEach((child, i) => {
    //         child.buyDates.forEach((ele) => {
    //             //判斷本日是不是有含在購買日期內
    //             if (
    //                 highestDiscount == null &&
    //                 dayjs().isSameOrAfter(dayjs(ele.startDate), 'year') &&
    //                 dayjs().isSameOrBefore(dayjs(ele.endDate), 'year')
    //             ) {
    //                 highestDiscount = sortedDiscount[i];
    //             }
    //         });
    //     });

    //     return highestDiscount || [];
    // };

    // const highestDiscount = calcHighestDiscount();

    //要把最高折價的折扣存進store
    // const setHighestDiscount = () => {
    //     let highestDiscounts =
    //         store_THSR.THSRInitData?.DiscountOff && store_THSR.THSRInitData?.DiscountOff.length > 0
    //             ? store_THSR.THSRInitData?.DiscountOff.filter(
    //                   (child) =>
    //                       child.percentOff >= highestDiscount.percentOff && child.percentOff > 15
    //               ).filter(
    //                   (child) =>
    //                       dayjs().isSameOrAfter(dayjs(child.buyDates[0].startDate), 'year') &&
    //                       dayjs().isSameOrBefore(dayjs(child.buyDates[0].endDate), 'year')
    //               )
    //             : [];
    //     highestDiscounts = highestDiscounts.map((child) => {
    //         return {
    //             ...child,
    //             aboardDates: generateDates(
    //                 child.aboardDates[0].startDate,
    //                 child.aboardDates[0].endDate
    //             ),
    //         };
    //     });
    // };

    // TODO: 可取代
    // const renderPrice = (type) => {
    //     let price = {
    //         LowSalePrice: 0,
    //         LowListPrice: 0,
    //     };
    //     if (type == TTripType.oneway && store_THSR?.THSRInitData?.OneWayPrice)
    //         price = store_THSR?.THSRInitData?.OneWayPrice;
    //     if (type == TTripType.round && store_THSR?.THSRInitData?.RoundPrice)
    //         price = store_THSR?.THSRInitData?.RoundPrice;

    //     return (
    //         <>
    //             <p className="price">
    //                 <span>{store_THSR?.THSRInitData?.SaleCurrency}</span>
    //                 <span className="pricetxt">{addSeparator(price?.LowSalePrice)}</span>
    //                 <span>起</span>
    //             </p>
    //             <p className="originalPrice">
    //                 <span>{store_THSR?.THSRInitData?.SaleCurrency}</span>
    //                 <span className="pricetxt">{addSeparator(price?.LowListPrice)}</span>
    //             </p>
    //         </>
    //     );
    // };

    // TODO: 可取代
    // const renderETItem = (item) => {
    //     return (
    //         <li className="ETItem">
    //             <IcRcln name="toolchoosenf" disabled={true} />
    //             <span>
    //                 {item}
    //             </span>
    //         </li>
    //     );
    // };

    const scrollTo = () => {
        // 滑動到點選的方案
        const listOpened = document.querySelector('.opened');
        const clickedRef = listBlockRef.current;
        const selectIndex = clickedRef.getAttribute('data-index');
        const OpenedIndex = listOpened?.getAttribute('data-index');
        if (listOpened && Number(selectIndex) > Number(OpenedIndex)) {
            /* 如果新點選的方案在已展開方案的後面則先直接跳動到前一個方案再往下滑
            避免因要同時收合已展開方案造成高度計算錯誤而無法scroll到正確位置 */
            clickedRef.previousSibling?.scrollIntoView({
                behavior: 'auto',
            });
            setTimeout(() => {
                clickedRef.scrollIntoView({
                    behavior: 'smooth',
                });
            }, 50);
        } else {
            // 其餘不會因收合造成計算高度錯誤的情況可直接smooth scroll
            clickedRef.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };

    // 打開方案
    const openOption = (isTHSRPanelOpen: boolean) => {
        console.log("點擊高鐵面板選擇按鈕")
        if (store_THSR.THSRDetailLoading) return;
        if (isGDS) {
            if(isGDSDetailLoading || isGDSSessionLoading) return;
        } else {
            if(isDetailLoading) return; //TODO:自建有場次API後要更改
        }

        if (isTHSRPanelOpen) {  // 當點擊'取消選擇'(關閉方案)
            dispatch(setFocusArea(Area.None));
            dispatch(setTCurrentStep(0));
            dispatch(setTHSROpenedPanel(''));
            dispatch(setTHSRDetailData(null)); 
        } else { // 當點擊'選擇出發時間'(打開方案)
            scrollTo();
            dispatch(setFocusArea(Area.THSR));
            DetailFetchFailMsg && dispatch(setDetailFetchFailMsg(null)); // 打開前先重置GDS/自建提示
            dispatch(setTCurrentStep(0));
            dispatch(setTHSROpenedPanel(props.THSRTripType));
            if (props.THSRTripType !== store_THSR.THSROpenedPanel) {
                dispatch(setTHSRDetailData(null));
            }
        }
        dispatch(setTHSRDepartTrain(null));
        dispatch(setTHSRReturnTrain(null));
        // 根據目前開起的面板要有不一樣的邏輯(?)
        // switch (store_THSR.TCurrentStep) {
        //     case TStep.first:
        //         break;
        //     case TStep.second:
        //         break;
        //     default:
        //         break;
        // }
    };

    // 初始化最高折扣存進store
    useEffect(() => {
        let highestDiscounts = THSRTripInfo?.ThsrDiscountDate 
            ? THSRTripInfo.ThsrDiscountDate
            : []
        dispatch(setTHSRHighestDiscounts(highestDiscounts));
    }, [THSRTripInfo]);

    return (
        <>
            <div
                className={cx('THSRContainer', {
                    opened: props.isTHSRPanelOpen,
                    closed: !props.isTHSRPanelOpen,
                    withShadow: props.isTHSRPanelOpen,
                })}
                ref={listBlockRef}
                data-index={props.listIndex}
            >
                {store_THSR?.THSRInitData && THSRTripInfo && (
                    
                    <div className="THSRheader">
                        <div className="titleContainer">
                        <div className="THSRtitle">
                            <div className="titleTxt"> {THSRTripInfo.ProjectName}</div>
                            {THSRTripInfo.HighestDiscountOff && 
                                <label 
                                    className={cx('titleLabel', {
                                        border: THSRTripInfo.HighestDiscountOff > 15,
                                        solid: THSRTripInfo.HighestDiscountOff <= 15
                                    })}
                                >
                                    {THSRTripInfo.ThsrDisPercentName}
                                </label>}
                        </div>
                        {/* 橘色注意事項 */}
                        {THSRTripInfo.HighestDiscountOff > 15 && (!props.isTHSRPanelOpen || isMobile)
                            ? <ul className="EventList">
                                {THSRTripInfo.ProjectDisMemo.map(((memo) => {
                                    return(
                                        <li>
                                            {memo}
                                        </li>
                                    )
                                }))}
                            </ul>
                            : null}
                        {/* ETITEMS */}
                        {!props.isTHSRPanelOpen || isMobile ? (
                            <ul className="ETItemList">
                                {THSRTripInfo.ProductItemNames.map((ProductItemName) => {
                                    return (
                                        <li className="ETItem">
                                            <IcRcln name="toolchoosenf" disabled={true} />
                                            <span>
                                                {ProductItemName}
                                            </span>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : null}
                    </div>
                    {/* 價錢 */}
                    <div
                        className={cx('priceContainer', {
                            hide: props.isTHSRPanelOpen && !isMobile,
                        })}
                    >
                        <>
                            <p className="price">
                                {isCrossell && showCrossellTag && (
                                    <div className="addOnPrice">
                                        <AddOnPriceTag />
                                </div>
                                )}
                                <span>{store_THSR.THSRInitData.SaleCurrency}</span>
                                <span className="pricetxt">{addSeparator(THSRTripInfo.ThsrWayPrice.LowSalePrice)}</span>
                                <span>{t('THSR.commonPanel.up')}</span>
                            </p>
                            <p className="originalPrice">
                                <span>{store_THSR.THSRInitData.SaleCurrency}</span>
                                <span className="pricetxt">{addSeparator(THSRTripInfo.ThsrWayPrice.LowListPrice)}</span>
                            </p>
                        </>
                    </div>
                    {/* 選擇按鈕 */}
                    {isMobile ? ( // mobile
                        <div className="buttonContainer">
                            <button
                                className={cx({
                                    disabled: isGDS 
                                        ? (isGDSDetailLoading || isGDSSessionLoading) 
                                        : isDetailLoading, //TODO:自建有場次API後要更改
                                })}
                                onClick={() => {
                                    if (isGDS) {
                                        if(isGDSDetailLoading || isGDSSessionLoading) return;
                                    } else {
                                        if(isDetailLoading) return; //TODO:自建有場次API後要更改
                                    }
                                    setOpenTHSRNvbRslb(true);
                                    handletBodyFixed(true);
                                    dispatch(setTHSROpenedPanel(props.THSRTripType));
                                    dispatch(setFocusArea(Area.THSR));
                                    DetailFetchFailMsg && dispatch(setDetailFetchFailMsg(null)); // 打開方案前先重置提示
                                }}
                            >
                                {t('THSR.commonPanel.choose', {particle:''})}
                            </button>
                        </div>
                    ) : ( // PC
                        <div className={cx('buttonContainer', { secondary: props.isTHSRPanelOpen })}>
                            <button
                                className={cx({
                                    disabled: isGDS 
                                        ? (isGDSDetailLoading || isGDSSessionLoading) 
                                        : isDetailLoading, //TODO:自建有場次API後要更改
                                })}
                                onClick={() => openOption(props.isTHSRPanelOpen)}
                            >
                                {props.isTHSRPanelOpen ? t('THSR.commonPanel.choose_cancel') : t('THSR.commonPanel.choose_DepartTime')}
                            </button>
                        </div>
                    )}
                    </div>
                )}
                {/*高鐵選擇面板PC版*/}
                {props.isTHSRPanelOpen && <THSRPanel THSRTripType={props.THSRTripType} />}
                {/* GDSTHSR || NormalTHSR */}
                {store_THSR.TCurrentStep === TStep.second && props.children}
            </div>

            {isMobile && (
                <NvbRslb visible={openTHSRNvbRslb} direction="right" className="THSRPlanM">
                    <div className="mobileBlock">
                        <MobileHeader
                            title={t('THSR.commonPanel.choose_THSR')}
                            onLeftIconClick={() => {
                                if (!store_THSR.THSRDetailLoading) {
                                    setOpenTHSRNvbRslb(false);
                                    handletBodyFixed(false);
                                    dispatch(setTCurrentStep(0));
                                    dispatch(setTHSRDetailData(null));
                                    dispatch(setFocusArea(Area.None));
                                }
                            }}
                        />
                        <div className="contentWrap">
                            {/*高鐵選擇面板M版*/}
                            {openTHSRNvbRslb && <THSRPanel THSRTripType={props.THSRTripType} />}
                        </div>
                    </div>
                </NvbRslb>
            )}
            {isMobile && props.THSRTripType === store_THSR.THSROpenedPanel && (
                <NvbRslb
                    visible={store_THSR.THSROptsMOpen}
                    direction="right"
                    className="THSRplan_slide"
                >
                    <MobileHeader
                        title={t('THSR.commonPanel.choose_ticket')}
                        onLeftIconClick={() => {
                            dispatch(setTHSROptsMOpen(false));
                            dispatch(setTCurrentStep(0));
                            dispatch(isGDS ? setTGRestore() : setTRestore());
                        }}
                    />
                    <div
                        className={cx('contentWrap', {
                            fixed: isGDS ? TGMInfoShow : MInfoShow,
                        })}
                    >
                        {/* GDSTHSR || NormalTHSR */}
                        {store_THSR.TCurrentStep === TStep.second && props.children}
                    </div>
                </NvbRslb>
            )}
        </>
    );
};

export default NormalRailPanel;